// ./src/components/lists/ListSalesVehicles/Item/index.tsx
import React, { useEffect, useState } from 'react';

import { BsFillTrashFill, BsLockFill } from 'react-icons/bs';
import { FaLock, FaUnlock } from 'react-icons/fa';
import { FiCornerUpRight } from 'react-icons/fi';
import { IoEllipsisHorizontal, IoEllipse } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';

import { Paragraph } from '@components/index';
import {
  ConfigRoutes,
  ConfigStyles,
  ConfigTransition,
  ConfigValues,
} from '@config/index';
import Contract from '@models/Contract';
import Vehicle from '@models/Vehicle';
import apiTraccarRebox from '@services/apis/apiTraccarRebox';
import { apiRebox } from '@services/index';
import { toastify } from '@utils/notifiers';

import {
  Container,
  CompositeItem,
  CompositeItemText,
  Dropdown,
  DropdownItem,
} from './styles';

interface IProps {
  vehicle: Vehicle;
}

const ListVehiclesItem: React.FC<IProps> = ({ vehicle }) => {
  const {
    location: { pathname },
  } = useHistory();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [contract, setContract] = useState<Contract>({} as Contract);

  const getContractByUser = async () => {
    const {
      data: {
        data: [response],
      },
    } = await apiRebox.get(`contracts`, {
      params: {
        users_id: vehicle.users_id,
      },
    });

    setContract(response);
  };

  const handleDeleteVehicleUncovered = async (vehicle_id: string) => {
    const isCovered: boolean =
      contract.contracts_vehicles?.[0].vehicles_id === vehicle_id;
    if (!isCovered) {
      try {
        await apiRebox.delete(`/users/vehicles/${vehicle_id}`);
      } catch (error) {
        toastify(
          'Não foi possível excluir o veículo, contrato existente',
          'error',
        );
        console.log(error);
      }
    }
  };

  const handleBlockVehicle = async (vehicle_id: string) => {
    try {
      const {
        data: { data: vehicleData },
      } = await apiRebox.get(`/users/vehicles/${vehicle_id}`);
      if (vehicleData?.gateway_tracker_device_id) {
        await apiTraccarRebox.post(`/commands/send`, {
          deviceId: vehicleData.gateway_tracker_device_id,
          description: 'Bloqueio de veiculo em caso de furto',
          type: 'engineStop',
          attributes: {},
        });
        toastify('Veículo bloqueado com sucesso.', 'success');
      }
    } catch (error) {
      toastify('Houve um erro ao bloquear o veículo.', 'error');
    }
  };

  useEffect(() => {
    getContractByUser();
  }, []);

  return (
    <Container onClick={() => setIsExpanded(prevState => !prevState)}>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {
          ConfigTransition.rebox_vehicles_classifications[
            vehicle.classification.toLowerCase() || 'undefined'
          ]
        }
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {vehicle.brand.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {vehicle.model.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {vehicle.license_plate.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {vehicle.year}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {ConfigTransition.rebox_vehicles_colors[vehicle.color.toLowerCase()]}
      </Paragraph>
      <CompositeItem>
        <IoEllipse
          size={10}
          color={
            ConfigValues.rebox.vehicle.status.active === vehicle.status
              ? ConfigStyles.rebox.colors.greenEmerald.main
              : ConfigStyles.rebox.colors.black.opacity.average
          }
        />
        <CompositeItemText>
          {
            ConfigTransition.rebox_vehicles_status[
              vehicle.status.toLowerCase() || 'undefined'
            ]
          }
        </CompositeItemText>
      </CompositeItem>

      <Paragraph nameColor="black" className="btn-options">
        <IoEllipsisHorizontal
          size={16}
          color={ConfigStyles.rebox.colors.black.main}
          style={{ cursor: 'pointer' }}
        />
      </Paragraph>
      <Dropdown expande={isExpanded}>
        <DropdownItem
          to={`${ConfigRoutes.rebox.privates.vehicles.path}/${vehicle.id}`}
        >
          <FiCornerUpRight
            size={16}
            title="ícone de editar"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Abrir
          </Paragraph>
        </DropdownItem>
        {vehicle?.chip_tracker_device_number && (
          <DropdownItem
            to={pathname}
            onClick={() => {
              handleBlockVehicle(vehicle.id);
            }}
          >
            {vehicle.is_blocked_in_traccar ? (
              <FaUnlock
                size={16}
                title="ícone de bloquear"
                color={ConfigStyles.rebox.colors.black.main}
              />
            ) : (
              <FaLock
                size={16}
                title="ícone de bloquear"
                color={ConfigStyles.rebox.colors.black.main}
              />
            )}
            <Paragraph
              nameColor="black"
              textAlign="start"
              fontSize={11}
              style={{
                marginLeft: '1vw',
                fontWeight: 500,
              }}
            >
              {vehicle.is_blocked_in_traccar
                ? 'Desbloquear veiculo'
                : 'Bloquear veiculo'}
            </Paragraph>
          </DropdownItem>
        )}

        <DropdownItem
          to={pathname}
          onClick={() => {
            handleDeleteVehicleUncovered(vehicle.id);
          }}
        >
          <BsFillTrashFill
            size={16}
            title="ícone de excluir"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Excluir (sem contrato)
          </Paragraph>
        </DropdownItem>

        {/* <DropdownButton>
          <IoTrash size={16} title="ícone de lixeira" color={ConfigStyles.rebox.colors.black.main} />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Excluir
          </Paragraph>
        </DropdownButton> */}
      </Dropdown>
    </Container>
  );
};

export default ListVehiclesItem;
